/**
 * Mirrors AlxAccounting.Domain.Security.Permissions. Kept as a flat object so a typo is a
 * TypeScript error rather than a button that silently never appears.
 */
export const P = {
  accounts: {
    view: 'accounts.view',
    create: 'accounts.create',
    edit: 'accounts.edit',
    deactivate: 'accounts.deactivate',
    import: 'accounts.import',
  },
  parties: {
    view: 'parties.view',
    create: 'parties.create',
    edit: 'parties.edit',
    deactivate: 'parties.deactivate',
  },
  cashBook: {
    view: 'cashbook.view',
    create: 'cashbook.create',
    edit: 'cashbook.edit',
    delete: 'cashbook.delete',
    reconcile: 'cashbook.reconcile',
  },
  journal: {
    view: 'journal.view',
    create: 'journal.create',
    edit: 'journal.edit',
    post: 'journal.post',
    review: 'journal.review',
    reverse: 'journal.reverse',
    backdate: 'journal.backdate',
  },
  periods: {
    view: 'periods.view',
    close: 'periods.close',
    lock: 'periods.lock',
    reopen: 'periods.reopen',
  },
  documents: {
    view: 'documents.view',
    create: 'documents.create',
    edit: 'documents.edit',
    review: 'documents.review',
    approve: 'documents.approve',
    post: 'documents.post',
  },
  reports: {
    view: 'reports.view',
    clientFunds: 'reports.clientfunds',
    payroll: 'reports.payroll',
    export: 'reports.export',
    taxPack: 'reports.taxpack',
  },
  currencies: {
    view: 'currencies.view',
    manage: 'currencies.manage',
  },
  admin: {
    users: 'admin.users',
    roles: 'admin.roles',
    settings: 'admin.settings',
    auditLog: 'admin.auditlog',
    sequences: 'admin.sequences',
  },
} as const
